import { Cell, Pie, PieChart, Tooltip } from 'recharts';

const data = [
  { name: 'Direct', value: 300.56 },
  { name: 'Affliate', value: 135.18 },
  { name: 'Sponsored', value: 154.02 },
  { name: 'E-mail', value: 48.96 },
];
const COLORS = ['#1c1c1c', '#baedbd', '#95a4fc', '#b1e3ff'];

export default function PieChartCircle() {
  return (
    <div className='w-[120px] h-[120px] mx-auto m-0 p-0'>
      <PieChart
        width={120}
        height={120}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      >
        <Pie
          data={data}
          cx={60}
          cy={60}
          innerRadius={36}
          outerRadius={48}
          fill="#8884d8"
          paddingAngle={4}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} stroke="none" />
          ))}
        </Pie>
        <Tooltip
          formatter={(value, name) => [`${value}`, name]}
          contentStyle={{ fontSize: '12px', borderRadius: '6px' }}
        />
      </PieChart>
    </div>
  );
}
